// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/KoPubWorld Batang Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 16px;
  font: inherit;
  vertical-align: baseline;
}

.dashboard-card-text-one {
  font-size: 20px;
  font-family: "HakgyoansimWoojuR";
}
.dashboard-card-text-two {
  font-size: 40px;
  color: gray;
  border: black;
  font-family: "MYYeongnamnu";
}
.dashboard-card-text-tree {
  font-size: 25px;
  border: black;
  font-weight: bold;
  font-family: "ChosunGu";
}
.custom-card-header {
  background: blue;
  color: white;
}

.cardStyle {
  border-radius: 10px; /* Added 'px' for correctness */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.07);
  transition: all 0.3s;

  border-top: 2px solid blue; /* this adds a subtle outline at the top of the card */
}

.cardStyle:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2), 0 10px 24px rgba(0, 0, 0, 0.15);
}

.titleStyle {
}

.contentStyle {
  fontsize: 16;
}
.icon-only-datepicker .ant-picker-input > input {
  visibility: hidden;
  width: 0;
  padding: 0;
}

.icon-only-datepicker .ant-picker-suffix {
  pointer-events: none; /* 아이콘을 클릭할 수 없게 만들지 않기 위해 */
}

.thicker-divider.ant-divider-horizontal {
  border-top-width: 1px; /* 원하는 선의 두께로 조절 */
  border-color: rgba(28, 27, 27, 0.85);
}

@font-face {
  font-family: "KoPubWorldBold";
  font-weight: 40;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: "HakgyoansimWoojuR";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2307-2@1.0/HakgyoansimWoojuR.woff2")
    format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "ChosunGu";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@1.0/ChosunGu.woff")
    format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "MYYeongnamnu";
  src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2206-02@1.0/MYYeongnamnu.woff2")
    format("woff2");
  font-weight: normal;
  font-style: normal;
}

.slick-dots li button:before {
  display: none;
}

iframe#webpack-dev-server-client-overlay {
  display: none !important;
}

.ant-breadcrumb {
  font-size: 20px;
  @media (max-width: 950px) {
    font-size: 14px;
  }
}

.ant-breadcrumb svg {
  font-size: 20px;
  @media (max-width: 950px) {
    font-size: 14px;
  }
}
.preview-image img {
  /* 원하는 크기로 조정 */
  width: 800px;
  height: 800px;
}

.ant-checkbox-inner,
.ant-checkbox-input {
  transform: scale(1.5);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB,EAAE,+BAA+B;EACpD,wEAAwE;EACxE,oBAAoB;;EAEpB,0BAA0B,EAAE,sDAAsD;AACpF;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;AACA;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,oBAAoB,EAAE,4BAA4B;AACpD;;AAEA;EACE,qBAAqB,EAAE,kBAAkB;EACzC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,4CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC;mBACiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;kBACgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B;mBACiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB","sourcesContent":["html,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 16px;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n.dashboard-card-text-one {\n  font-size: 20px;\n  font-family: \"HakgyoansimWoojuR\";\n}\n.dashboard-card-text-two {\n  font-size: 40px;\n  color: gray;\n  border: black;\n  font-family: \"MYYeongnamnu\";\n}\n.dashboard-card-text-tree {\n  font-size: 25px;\n  border: black;\n  font-weight: bold;\n  font-family: \"ChosunGu\";\n}\n.custom-card-header {\n  background: blue;\n  color: white;\n}\n\n.cardStyle {\n  border-radius: 10px; /* Added 'px' for correctness */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.07);\n  transition: all 0.3s;\n\n  border-top: 2px solid blue; /* this adds a subtle outline at the top of the card */\n}\n\n.cardStyle:hover {\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2), 0 10px 24px rgba(0, 0, 0, 0.15);\n}\n\n.titleStyle {\n}\n\n.contentStyle {\n  fontsize: 16;\n}\n.icon-only-datepicker .ant-picker-input > input {\n  visibility: hidden;\n  width: 0;\n  padding: 0;\n}\n\n.icon-only-datepicker .ant-picker-suffix {\n  pointer-events: none; /* 아이콘을 클릭할 수 없게 만들지 않기 위해 */\n}\n\n.thicker-divider.ant-divider-horizontal {\n  border-top-width: 1px; /* 원하는 선의 두께로 조절 */\n  border-color: rgba(28, 27, 27, 0.85);\n}\n\n@font-face {\n  font-family: \"KoPubWorldBold\";\n  font-weight: 40;\n  src: url(\"./font/KoPubWorld Batang Bold.ttf\");\n}\n\n@font-face {\n  font-family: \"HakgyoansimWoojuR\";\n  src: url(\"https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2307-2@1.0/HakgyoansimWoojuR.woff2\")\n    format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"ChosunGu\";\n  src: url(\"https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@1.0/ChosunGu.woff\")\n    format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"MYYeongnamnu\";\n  src: url(\"https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2206-02@1.0/MYYeongnamnu.woff2\")\n    format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.slick-dots li button:before {\n  display: none;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n\n.ant-breadcrumb {\n  font-size: 20px;\n  @media (max-width: 950px) {\n    font-size: 14px;\n  }\n}\n\n.ant-breadcrumb svg {\n  font-size: 20px;\n  @media (max-width: 950px) {\n    font-size: 14px;\n  }\n}\n.preview-image img {\n  /* 원하는 크기로 조정 */\n  width: 800px;\n  height: 800px;\n}\n\n.ant-checkbox-inner,\n.ant-checkbox-input {\n  transform: scale(1.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
